import { getHomePageUrl } from 'utils/navigation';

export const crudBreadcrumbs = (): any => [
  {
    href: getHomePageUrl(),
    label: 'Начало',
  },
];
